module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/073-togo-007827ebca721753938092182240015b.svg";